// extracted by mini-css-extract-plugin
export default {"saved":"SavedStorisPage_saved__ohc9o"};